export const DashboardType={
    INTERVIEWER:"iv-interviewer-web-app",
    OPS:"iv-ops-web-app",
    CLIENT:"iv-client-web-app"
  }